import { render, staticRenderFns } from "./longTerm.vue?vue&type=template&id=15af4b82&scoped=true&"
import script from "./longTerm.vue?vue&type=script&lang=js&"
export * from "./longTerm.vue?vue&type=script&lang=js&"
import style0 from "./longTerm.vue?vue&type=style&index=0&id=15af4b82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15af4b82",
  null
  
)

export default component.exports